import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Enrollment } from '../models/enrollment.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnrollmentService {

  readonly ENROLLMENT_URL = environment.baseServerUrl + 'enrollments'
  constructor(private httpClient: HttpClient) { }

    createEnrollment(enrollment: any): Observable<Enrollment> {
      return this.httpClient.post<Enrollment>(this.ENROLLMENT_URL, enrollment)
    }
    findEnrollmentsByStudent(studentId: string): Observable<Enrollment[]> {
      return this.httpClient.get<Enrollment[]>(this.ENROLLMENT_URL + `/${studentId}`);
    }

    findEnrollmentByStudentLesson(studentId: string, lessonId: string): Observable<Enrollment> {
      return this.httpClient.get<Enrollment>(this.ENROLLMENT_URL + `/student/${studentId}/lesson/${lessonId}`)
    }
}
